import moment from "moment";
import { getBackendApiInstance, getInternalApiInstance } from "./base";
import { CheckInFormData } from "../pages/CheckIn";

export interface CloneUserRequest {
  cloneEmail: string;
  sourceUserId: string;
}

export const getUserCheckInDetails = async (userId: string) => {
  const api = await getInternalApiInstance();
  const reqBody = { userId };
  try {
    const response = await api.post("/admin/checkin", { ...reqBody });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const getUserWeightEma8Details = async (userId: string) => {
  const api = await getBackendApiInstance();
  const reqBody = { 
    userId,
    metric: "weight",
    valueType: "ema8",
    startDate: moment().subtract(60, "days")
        .startOf("day")
        .toISOString()
  };
  try {
    const response = await api.post("/admin/user-analytics", { ...reqBody });
    return response.data;
  } catch (error) {
    throw error;
  }
}

const prepareDataForNutritionTarget = (data: CheckInFormData) => {
  const { gender, level, goal, bodyFat, heightCm, currentCalorieTarget } = data;
  const weightData: { date: string; value: number }[] = [];
  const nutritionData: { date: string; value: number }[] = [];
  const weightEma8Data: { date: string; value: number }[] = [];

  [7, 6, 5, 4, 3, 2, 1].forEach((dayOffset, i) => {
    const dateKey = moment().subtract(dayOffset, "days").startOf("day").toISOString();
    const weightKey = `weight${i+1}` as keyof CheckInFormData;
    const calorieKey = `calorieIntake${i+1}` as keyof CheckInFormData;
    const weightEmaKey = `weightEma${i+1}` as keyof CheckInFormData;

    if (typeof data[weightKey] === "number" && data[weightKey] > 0) {
      weightData.push({
        date: dateKey,
        value: data[weightKey] as number
      });
    }
    if (typeof data[calorieKey] === "number" && data[calorieKey] > 0) {
      nutritionData.push({
        date: dateKey,
        value: data[calorieKey] as number
      });
    }
    if (typeof data[weightEmaKey] === "number" && data[weightEmaKey] > 0) {
      weightEma8Data.push({
        date: dateKey,
        value: data[weightEmaKey] as number
      });
    }
  });

  return {
    weightData,
    weightEma8Data,
    nutritionData,
    userInfo: {
      gender, level, goal, bodyFat, heightCm
    },
    currentCalorieTarget,
  };
}

export const getNewNutritionTargetDetails = async (data: CheckInFormData) => {
  const api = await getBackendApiInstance();

  const transformedData = prepareDataForNutritionTarget(data);

  const reqBody = { ...transformedData };

  try {
    const response = await api.post("/checkin/target", { ...reqBody });
    return response.data;
  } catch (error) {
    throw error;
  }
};